import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-0cff43a5"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_3 = {
  class: "d-flex flex-wrap lang"
};
import { baseGet, basePost, Staff } from "@/js/services/baseService";
import { ajax200Res } from '@/js/utils';
import store from "@/store/store.js";
import { useI18n } from "vue-i18n";
export default {
  __name: 'Menu',
  setup(__props) {
    const {
      t,
      locale
    } = useI18n();

    // auth
    const authInfo = store.getters['auth/authInfo'];
    const staffInfoData = store.getters['staffInfo'];

    // 切換語系
    const switchLanguage = lang => {
      console.log('switchLanguage', lang);
      switch (lang) {
        case 'tw':
          store.commit('updateLocale', mukiConst.locale.TW);
          break;
        case 'en':
          store.commit('updateLocale', mukiConst.locale.EN);
          break;
        case 'th':
          store.commit('updateLocale', mukiConst.locale.TH);
          break;
        case 'kr':
          store.commit('updateLocale', mukiConst.locale.KR);
          break;
        case 'vn':
          store.commit('updateLocale', mukiConst.locale.VN);
          break;
        case 'bd':
          store.commit('updateLocale', mukiConst.locale.BD);
          break;
        case 'id':
          store.commit('updateLocale', mukiConst.locale.ID);
          break;
        case 'tr':
          store.commit('updateLocale', mukiConst.locale.TR);
          break;
        case 'uz':
          store.commit('updateLocale', mukiConst.locale.UZ);
          break;
        case 'ru':
          store.commit('updateLocale', mukiConst.locale.RU);
          break;
        case 'es':
          store.commit('updateLocale', mukiConst.locale.ES);
          break;
        case 'ab':
          store.commit('updateLocale', mukiConst.locale.AB);
          break;
        default:
          break;
      }
    };
    const logout = () => {
      Staff.logout().then(res => {
        const {
          onSuccess,
          onFail
        } = ajax200Res(res);
        onSuccess(({
          res,
          data,
          msg,
          defaultAlert
        }) => {
          _alert_custom(t('hint'), msg, function () {
            localStorage.removeItem('staffPermissions');
            localStorage.removeItem('staffName');
            localStorage.removeItem('staffCode');
            f7.panel.close();
            _back_page('/login');
          });
        });
        onFail(({
          res,
          data,
          msg,
          defaultAlert
        }) => {
          _alert_custom(t('hint'), msg, function () {});
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_f7_link = _resolveComponent("f7-link");
      const _component_f7_block = _resolveComponent("f7-block");
      const _component_f7_list_item = _resolveComponent("f7-list-item");
      const _component_f7_list = _resolveComponent("f7-list");
      const _component_f7_button = _resolveComponent("f7-button");
      const _component_f7_page = _resolveComponent("f7-page");
      const _component_f7_panel = _resolveComponent("f7-panel");
      return _openBlock(), _createBlock(_component_f7_panel, {
        id: "panel-page",
        right: "",
        cover: "",
        backdrop: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_f7_page, {
          class: "p-menu"
        }, {
          default: _withCtx(() => [_createVNode(_component_f7_block, {
            class: "header"
          }, {
            default: _withCtx(() => [_createVNode(_component_f7_link, {
              class: "close",
              icon: "icon-close",
              color: "white",
              "panel-close": ""
            }), _hoisted_1, _createElementVNode("p", null, [_createTextVNode(" Hi, " + _toDisplayString(_unref(store).state.staff.name), 1), _hoisted_2, _createTextVNode(" / " + _toDisplayString(_unref(store).state.staff.code), 1)])]),
            _: 1
          }), _createVNode(_component_f7_block, {
            class: "m-0 p-0"
          }, {
            default: _withCtx(() => [_createVNode(_component_f7_list, {
              class: "m-0"
            }, {
              default: _withCtx(() => [_unref(store).state.staff.ordersPermission ? (_openBlock(), _createBlock(_component_f7_list_item, {
                key: 0,
                title: _ctx.$t('salesOrder'),
                link: "/",
                "panel-close": ""
              }, null, 8, ["title"])) : _createCommentVNode("", true), _unref(store).state.staff.muPermission ? (_openBlock(), _createBlock(_component_f7_list_item, {
                key: 1,
                title: _ctx.$t('muMachineInvestigation'),
                link: "/inquire",
                "panel-close": ""
              }, null, 8, ["title"])) : _createCommentVNode("", true)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_f7_block, {
            style: {
              "padding": "20px",
              "margin": "auto 0 0"
            }
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[0] || (_cache[0] = $event => switchLanguage('tw')),
              fill: _unref(locale) === 'tw',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("中文")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[1] || (_cache[1] = $event => switchLanguage('en')),
              fill: _unref(locale) === 'en',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("English")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[2] || (_cache[2] = $event => switchLanguage('th')),
              fill: _unref(locale) === 'th',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("แบบไทย")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[3] || (_cache[3] = $event => switchLanguage('kr')),
              fill: _unref(locale) === 'kr',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("한국어")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[4] || (_cache[4] = $event => switchLanguage('id')),
              fill: _unref(locale) === 'id',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("Indonesia")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[5] || (_cache[5] = $event => switchLanguage('tr')),
              fill: _unref(locale) === 'tr',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("Türkçe")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[6] || (_cache[6] = $event => switchLanguage('uz')),
              fill: _unref(locale) === 'uz',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("o'zbek")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[7] || (_cache[7] = $event => switchLanguage('ru')),
              fill: _unref(locale) === 'ru',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("Русский")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[8] || (_cache[8] = $event => switchLanguage('es')),
              fill: _unref(locale) === 'es',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("español")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[9] || (_cache[9] = $event => switchLanguage('ab')),
              fill: _unref(locale) === 'ab',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("عربي")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[10] || (_cache[10] = $event => switchLanguage('vn')),
              fill: _unref(locale) === 'vn',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("Tiếng Việt")]),
              _: 1
            }, 8, ["fill"]), _createVNode(_component_f7_button, {
              class: "language-button",
              onClick: _cache[11] || (_cache[11] = $event => switchLanguage('bd')),
              fill: _unref(locale) === 'bd',
              outline: ""
            }, {
              default: _withCtx(() => [_createTextVNode("বাংলা")]),
              _: 1
            }, 8, ["fill"])])]),
            _: 1
          }), !_unref(authInfo).offLine ? (_openBlock(), _createBlock(_component_f7_block, {
            key: 0,
            class: "m-0",
            style: {
              "padding": "10px 20px",
              "border-top": "1px solid #F2F0F0"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_f7_button, {
              onclick: logout,
              class: "w-full logout",
              icon: "icon-signout",
              href: "javascript:;"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('logout')), 1)]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};